import {
  clearSchemaDetails,
  fetchSchemaNameFail,
  fetchSchemaNameStarted,
  fetchSchemaNameSuccess
} from '../../../reducer/events/SchemaNameReducer';
import {
  ClearSchemas,
  FetchSchemaFailure,
  FetchSchemaFailurePayload,
  FetchSchemaStarted,
  FetchSchemaSuccess,
  FetchSchemaSuccessPayload
} from '../../types/events/FetchSchemaDetailTypes';

/**
 * Fetch schema started saga action
 * @returns schema started action
 */
export const fetchSchemaStarted = (): FetchSchemaStarted => ({
  type: fetchSchemaNameStarted.type
});

/**
 * Fetch schema success saga action
 * @param payload :schema data
 * @returns success action
 */
export const fetchSchemaSuccess = (
  payload: FetchSchemaSuccessPayload
): FetchSchemaSuccess => ({
  type: fetchSchemaNameSuccess.type,
  payload
});

/**
 * Fetch Schema Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchSchemaFailure = (
  payload: FetchSchemaFailurePayload
): FetchSchemaFailure => ({
  type: fetchSchemaNameFail.type,
  payload
});

/**
 * Clear Schema saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearSchemas = (): ClearSchemas => ({
  type: clearSchemaDetails.type
});
